import { Form, Input } from 'antd';
import React, { FC } from 'react';
import styles from '../AnnotationForm.module.scss';

type Props = {
  label: string;
  placeholder: string;
  disabled: boolean;
  value: string;
  required: boolean;
  rows: number | undefined;
  onChange: (value: string) => void;
};

const AssessmentInput: FC<Props> = ({ label, placeholder, disabled, value, required, rows, onChange }) => {
  return (
    <Form.Item className={styles.comment} label={label} required={required}>
      <Input.TextArea disabled={disabled} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} rows={rows} />
    </Form.Item>
  );
};

export default AssessmentInput;
